<script>
    import { onMount } from "svelte";
    import { push } from "svelte-spa-router";
    import { resetWorkMngStore } from "../stores/workMng.store";
    import { resetMemoMngStore } from "../stores/memoMng.store";
    import { apiGetStatus, apiGetLogout } from "../stores/auth.store";

    function menu_close() {
        const menu = document.querySelector(".menu");
        menu.style.zIndex = "-1";
        menu.classList.remove("show-use");
    }

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();
    });

    async function logout() {
        await apiGetLogout();
    }
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="menu">
    <div class="window">
        <div class="popup">
            <div class="popup-in">
                <div class="popup-hd">
                    <p>menu</p>
                    <img
                        src="../resource/img/ico_hd_close.png"
                        class="popup-close"
                        on:click={menu_close}
                    />
                </div>
                <div
                    class="p-menu p-menu-schedule"
                    on:click={() => {
                        if (window.location.hash === "#MemoMng") {
                            window.location.reload();
                        } else {
                            resetMemoMngStore();
                            push("/MemoMng");
                            menu_close();
                        }
                    }}
                >
                    <p>스케쥴</p>
                </div>

                <div
                    class="p-menu p-menu-bcnc"
                    on:click={() => {
                        if (window.location.hash === "#WorkMng") {
                            window.location.reload();
                        } else {
                            resetWorkMngStore();
                            push("/WorkMng");
                            menu_close();
                        }
                    }}
                >
                    <p>작업중</p>
                </div>
                <div class="p-menu" on:click={logout}>
                    <p>로그아웃</p>
                </div>
            </div>
        </div>
    </div>
</div>
